import { Opportunity } from '@axiom/const'; // eslint-disable-line project-structure/folder-structure -- legacy shared constants file; renaming is out of scope for this lint upgrade

// Note: these names are not camelcase because they are included in error messages
export const BANNER_MESSAGE_API_NAME = 'Banner Messages API';
export const COMPANIES_API_NAME = 'Companies API';
export const CONTACTS_API_NAME = 'Contacts API';
export const JOB_API_NAME = 'Jobs API';
export const JOB_CANDIDATES_API_NAME = 'Job Candidates API';
export const CANDIDATE_ACTIVITIES_API_NAME = 'Candidate Activities API';
export const CANDIDATE_API_NAME = 'Candidate API';
export const CANDIDATE_EXPERIENCES_API_NAME = 'Candidate Experiences API';
export const CANDIDATE_LANGUAGES_API_NAME = 'Candidate Languages API';
export const CANDIDATE_OPPORTUNITIES_API_NAME = 'Candidate Opportunities API';
export const TYPEAHEAD_API_NAME = 'Typeaheads API';
export const USERS_API_NAME = 'Users API';
export const USER_API_NAME = 'User API';
